import DOMPurify from 'dompurify';

export default {
	name: 'HtmlViewer',

	props: {
		content: {
			type: String,
			default: '',
		},
	},

	computed: {
		sanitizedContent() {
			if (!this.content || this.content.trim() === '') return '-';

			// If content has no HTML tags, wrap in <p> for consistent display
			const hasHtml = /<[a-z][\s\S]*>/i.test(this.content);
			let rawHtml = hasHtml ? this.content : `<p>${this.content}</p>`;
			
			// Ensure content is not just empty tags
			const tempDiv = document.createElement('div');
			tempDiv.innerHTML = rawHtml;
			const textContent = tempDiv.textContent?.trim();
			if (!textContent) return '<p>-</p>';

			return DOMPurify.sanitize(rawHtml, {
				ALLOWED_TAGS: [
					'p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'del',
					'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
					'ul', 'ol', 'li',
					'blockquote', 'hr',
					'table', 'thead', 'tbody', 'tr', 'th', 'td',
					'img', 'a', 'span', 'div',
					'colgroup', 'col',
				],
				ALLOWED_ATTR: [
					'src', 'alt', 'title', 'width', 'height',
					'href', 'target', 'rel',
					'class', 'style',
					'colspan', 'rowspan',
					'align', 'valign',
					'data-colwidth',
				],
				ALLOW_DATA_ATTR: false,
			});
		},
	},
};
